import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Route, Switch, useHistory, useLocation, Redirect } from "react-router-dom";

import logo from '../../../static/logo/shui_engine.png'
import member_icon_selected from '../../../static/icon/member.png'
import pay_icon_selected from '../../../static/icon/pay.png'


import member_icon from '../../../static/icon/member_selected.png'
import pay_icon from '../../../static/icon/pay_selected.png'

import Admin from './map';
import UserPool from './pool';

import { logout,indistinct_show } from '../../../actions/user'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Switchs from '@mui/material/Switch';



const _ = require('micro-dash');

function Index() {
    console.log(233)
    const [lefTab, setlefTab] = React.useState(0);
    const [checked, setChecked] = React.useState(true);
    const token = useSelector((state) => state.user.token);
    const avatar = useSelector((state) => state.user.avatar);
    const nick_name = useSelector((state) => state.user.nick_name);
    const user_id = useSelector((state) => state.user.user);
    const dispatch = useDispatch();
    const location = useLocation();
    console.log(`locayion: ${location.pathname}`)
    const history = useHistory();
    const indistinct_checked = useSelector((state) => state.user.indistinct_checked);

    useEffect(() => {
        // dispatch(web_qr_code({mini_type:1,coupon_uid:null,level:1}))
        switch (location.pathname) {
            case "/admin":
                setlefTab(0);
                break;
            case "/admin/pool":
                setlefTab(1);
                break;
            default:
                setlefTab(0);
        }
    }, []);
    // useEffect(() => {
    //     console.log('mine_index')
    //     dispatch(user_member_info(1))
    // }, []);

    useEffect(() => {
        console.log(`token is ${token}`)
        if (_.isNil(token)) {
            return <Redirect to={'/'} />;
        }
    }, [token]);

    useEffect(() => {
        console.log(location.pathname)
        switch (location.pathname) {
            case "/admin":
                setlefTab(0);
                break;
            case "/admin/pool":
                setlefTab(1);
                break;
            default:
                setlefTab(0);
        }
    }, [location.pathname]);

    const drop_out_login = () => {
        window.localStorage.clear()
        dispatch(logout())
        history.replace('/')
    }
    console.log(`token is ${token}`)
    if (_.isNil(token)) {
        return <Redirect to={'/'} />;
    }
    
    
    const handleChange = (event) => {
        // setChecked(event.target.checked);
        dispatch(indistinct_show(event.target.checked))
    };
    return (
        <div style={{ display: 'flex', }}>
            <div style={{ minHeight: '100vh', width: '10vw', position: 'relative', minWidth: '150px' }}>
                <div style={{ height: 'calc(80% - 1px)', borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                    <Link to='/'>
                        <div style={{ display: 'flex', padding: 20, cursor: "pointer", paddingRight: 0, paddingTop: 15, paddingBottom: 8 }}>
                            <div>
                                <img style={{ width: 30, height: 30 }} src={logo} alt='' />
                            </div>
                            <div style={{ paddingLeft: 10, lineHeight: '30px', fontSize: '15px' }}>博槐ADMIN</div>
                        </div>
                    </Link>
                    <Link to='/admin'>
                        <div onClick={() => setlefTab(0)} style={{ cursor: "pointer", display: 'flex', padding: '8px 20px', margin: '10px 0', background: lefTab === 0 ? '#3D1198' : '' }}>
                            <div>
                                <img src={lefTab === 0 ? member_icon : member_icon_selected} alt='' style={{ width: 20, height: 20, paddingTop: 2 }} />
                            </div>
                            <div style={{ paddingLeft: 10, fontSize: 14, color: lefTab === 0 ? '#fff' : '' }}>潜在用户</div>
                        </div>
                    </Link>
                    <Link to='/admin/pool'>
                        <div onClick={() => setlefTab(1)} style={{ cursor: "pointer", display: 'flex', padding: '8px 20px', margin: '10px 0', background: lefTab === 1 ? '#3D1198' : '' }}>
                            <div>
                                <img src={lefTab === 1 ? pay_icon : pay_icon_selected} alt='' style={{ width: 20, height: 20, paddingTop: 2 }} />
                            </div>
                            <div style={{ paddingLeft: 10, fontSize: 14, color: lefTab === 1 ? '#fff' : '' }}>用户池</div>
                        </div>
                    </Link>
                </div>
                <div style={{ width: '100%', textAlign: 'right', height: '20%' }}>
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                            <div>
                                {
                                    avatar === '' ? <AccountCircleIcon sx={{ fontSize: 30, color: 'rgba(0, 0, 0, 0.26)' }} color="disabled" /> : <img style={{ width: 30, height: 30, borderRadius: '50%' }} src={avatar} alt='' />
                                }
                            </div>
                            {
                                _.isNil(nick_name) || nick_name === "null" ? <div style={{ lineHeight: '30px', paddingLeft: '10px', fontSize: 15 }}>{'用户00' + user_id}</div> : <div style={{ lineHeight: '30px', paddingLeft: '10px', fontSize: 13 }}>{nick_name}</div>
                            }
                        </div>
                        <div onClick={drop_out_login} style={{ padding: '8px 10px', background: '#3D1198', color: '#fff', borderRadius: 8, cursor: "pointer", width: '50%', margin: '0 auto', textAlign: 'center', fontSize: '13px' }}>退出登录</div>
                    </div>
                </div>
            </div>
            <div style={{ width: '90vw' }}>
                <div>
                    <div style={{ display: 'flex', justifyContent: "space-between", padding: '20px' }}>
                        <div style={{ display: 'flex' }}>
                            <div>
                                {
                                    avatar === '' ? <AccountCircleIcon sx={{ fontSize: 30, color: 'rgba(0, 0, 0, 0.26)' }} color="disabled" /> : <img style={{ width: 30, height: 30, borderRadius: '50%' }} src={avatar} alt='' />
                                }
                            </div>
                            {
                                _.isNil(nick_name) || nick_name === "null" ? <div style={{ lineHeight: '30px', paddingLeft: '10px', fontSize: 15 }}>{'用户00' + user_id}</div> : <div style={{ lineHeight: '30px', paddingLeft: '10px', fontSize: 13 }}>{nick_name}</div>
                            }
                        </div>
                        <div onClick={drop_out_login} style={{ padding: '8px 10px', background: '#3D1198', color: '#fff', borderRadius: 8, cursor: "pointer",  textAlign: 'center', fontSize: '13px' }}>退出登录</div>
                    </div>
                    <div>
                        <Switchs
                            checked={indistinct_checked}
                            onChange={handleChange}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                        模糊开关
                    </div>
                </div>
                <div style={{ padding: '40px 50px', background: 'rgba(204,153,204,0.05)', minHeight: 'calc(100vh - 80px)',paddingTop:30 }}>
                    <Switch>
                        <Route exact path="/admin" component={Admin} />
                        <Route path="/admin/pool" component={UserPool} />
                    </Switch>
                </div>
            </div>
        </div>
    )
}

export default Index;